import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'superId',
        fieldName: '上级菜单',
        placeholder: '',
        value: 0,
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: false,
          isDisabled: true,
          multiple: false,
          clearable: false,
          selectType: 3 // 1本地2远程
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'type',
        fieldName: '菜单类型',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [
          { name: '菜单', id: 1 },
          { name: '按钮', id: 2 }
        ],
        config: {
          collapseTags: false,
          isDisabled: false,
          multiple: false,
          clearable: true,
          filterable: true,
          selectType: 3// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '菜单名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'order',
        fieldName: '排序',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'path',
        fieldName: '路由地址',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'icon',
        fieldName: '菜单图标',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'method',
        fieldName: '请求方法',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'HttpMethodType',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'url',
        fieldName: '后端页面路径',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }
    ]
  }

]
